import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { contentStatsFetchStateConfig } from "../../../consts";
import { ContentStats } from "./stats";

export { default as ContentStat } from "./stats/stat";
export type { ContentStatType, OptionalContentStatType } from "./stats/stat";

export type { ContentStats };

export type ContentStatsStateSliceType = {
  stats: ContentStats;
  meta: CrudBuilderState;
};

const contentStatsMetaInitialState = makeCrudBuilderInitialState(
  contentStatsFetchStateConfig
);

export default class ContentStatsStateSlice extends Record({
  stats: Map(),
  meta: contentStatsMetaInitialState
}) {}
